function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { getInitialResults } from "instantsearch.js/es/lib/server.js";
import { resetWidgetId, walkIndex } from "instantsearch.js/es/lib/utils/index.js";
import { ServerInsertedHTMLContext } from "next/navigation.js";
import React, { useContext } from 'react';
import { useInstantSearchContext, useRSCContext, wrapPromiseWithState } from 'react-instantsearch-core';
import { htmlEscapeJsonString } from "./htmlEscape.js";
var _ref2 = /*#__PURE__*/React.createElement(React.Fragment, null);
var createInsertHTML = function createInsertHTML(_ref) {
  var options = _ref.options,
    results = _ref.results,
    nonce = _ref.nonce;
  return function () {
    if (options.inserted) {
      return _ref2;
    }
    options.inserted = true;
    return /*#__PURE__*/React.createElement("script", {
      nonce: nonce,
      dangerouslySetInnerHTML: {
        __html: "window[Symbol.for(\"InstantSearchInitialResults\")] = ".concat(htmlEscapeJsonString(JSON.stringify(results)))
      }
    });
  };
};
export function InitializePromise(_ref3) {
  var nonce = _ref3.nonce;
  var _search = useInstantSearchContext();
  var waitForResultsRef = useRSCContext();
  var insertHTML = useContext(ServerInsertedHTMLContext) || function () {
    throw new Error('Missing ServerInsertedHTMLContext');
  };

  // Extract search parameters from the search client to use them
  // later during hydration.
  var requestParamsList;
  _search.mainHelper.setClient(_objectSpread(_objectSpread({}, _search.mainHelper.getClient()), {}, {
    search: function search(queries) {
      requestParamsList = queries.map(function (_ref4) {
        var params = _ref4.params;
        return params;
      });
      return _search.client.search(queries);
    }
  }));
  resetWidgetId();
  var waitForResults = function waitForResults() {
    return new Promise(function (resolve) {
      var searchReceived = false;
      var recommendReceived = false;
      _search.mainHelper.derivedHelpers[0].once('result', function () {
        searchReceived = true;
        if (!_search._hasRecommendWidget || recommendReceived) {
          resolve();
        }
      });
      _search.mainHelper.derivedHelpers[0].once('recommend:result', function () {
        recommendReceived = true;
        if (!_search._hasSearchWidget || searchReceived) {
          resolve();
        }
      });
    });
  };
  var injectInitialResults = function injectInitialResults() {
    var options = {
      inserted: false
    };
    var results = getInitialResults(_search.mainIndex, requestParamsList);
    insertHTML(createInsertHTML({
      options: options,
      results: results,
      nonce: nonce
    }));
  };
  if ((waitForResultsRef === null || waitForResultsRef === void 0 ? void 0 : waitForResultsRef.current) === null) {
    waitForResultsRef.current = wrapPromiseWithState(waitForResults().then(function () {
      var shouldRefetch = false;
      walkIndex(_search.mainIndex, function (index) {
        shouldRefetch = index.getWidgets().some(function (widget) {
          return widget.$$type === 'ais.dynamicWidgets';
        });
      });
      if (shouldRefetch) {
        waitForResultsRef.current = wrapPromiseWithState(waitForResults().then(injectInitialResults));
      }
      return shouldRefetch;
    }).then(function (shouldRefetch) {
      if (shouldRefetch) {
        return;
      }
      injectInitialResults();
    }));
  }
  return null;
}